import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '@env/environment';
import { GameCategory } from '@lbsdk/*';

@Component({
  selector: 'app-category-form',
  templateUrl: './category-form.component.html',
  styleUrls: ['./category-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CategoryFormComponent implements OnInit {

  dialogTitle: string;
  categoryForm: FormGroup;
  action: string;
  categoryData: GameCategory;

  constructor(
    public dialogRef: MatDialogRef<CategoryFormComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder
  ) {
    this.action = data.action || 'create';
    this.categoryData = data.categoryData || new GameCategory();
    this.dialogTitle = 'Category Info';
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.categoryForm = this.formBuilder.group({
      name: [this.categoryData.name || '', Validators.required],
      image: [null, this.action === 'edit' ? [] : Validators.required] // ⬅️ ALWAYS null
    });
  }

  onSave() {
    let formValue = this.categoryForm.value;
  
    let result = Object.assign({}, this.categoryData, {
      name: formValue.name,
      image: formValue.image ? formValue.image : this.categoryData.image
    });
  
    this.dialogRef.close({
      action: this.action,
      data: result
    });
  }

  // Put this in a service or component
    getImageUrl(image: string): string {
      if (!image) {
        return '/assets/images/image-not-found.png';
      }
    
      // Check if it's a base64 string
      if (typeof image === 'string' && image.indexOf('data:') === 0) {
        return image;
      }
    
      // Otherwise, assume it's an S3 file name and prepend bucket URL
      return environment.s3BucketUrl + image;
    }
}
